const initialState = {
    user: null,
    branch : null,
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USER':
            return { ...state, user: action.user }
        case 'SET_BRANCH' : 
            return { ...state, branch : action.branch }
        default:
            return state;
    }
}

export default authReducer;